import { createVote } from '@/lib/server-functions/create-vote';
import { useMutation } from '@tanstack/react-query';

type NewVote = {
  pollId: string;
  optionId: string;
  pollAuthorId: string;
  pollQuestion: string;
};

export const useCreateVote = () => {
  return useMutation({
    mutationFn: async (payload: NewVote) => {
      await createVote({ data: payload });
    },
  });
};
